import {
  CustomTagTokko,
  Development,
  DevelopmentMediacore,
  Property,
  PropertyMediacore,
} from 'types'

export const getLocation = (data: Development | Property | PropertyMediacore, all = false) => {
  if (data) {
    if (data.location && all) {
      if (data.location.neighborhood) {
        return [data.location.neighborhood, data.location.state]
      }
      return [
        data.location.full_location.split(' | ')[2].endsWith(' ')
          ? data.location.full_location.split(' | ')[2].slice(0, -1)
          : data.location.full_location.split(' | ')[2],
        data.location.full_location.split(' | ')[4] || data.location.full_location.split(' | ')[1],
      ]
    }
    if (data.location) {
      if (data.location.city) {
        return data.location.city
      }
      return data.location.full_location.split(' | ')[1]
    }
  }
  return ['Sin Ubicación', 'Sin Ubicación']
}
export const getFakeAddress = (development: Development | DevelopmentMediacore | Property) => {
  return development?.fake_address.replace(/\s+$/, '') || development?.address.replace(/\s+$/, '')
}
export const getName = (development: Development | DevelopmentMediacore) => {
  return development?.name
}
export const getFeatured = (developments: Development[] | DevelopmentMediacore[]) => {
  return developments?.filter(
    (development: Development | DevelopmentMediacore) => development.is_starred_on_web,
  )
}
export const getTitle = (development: Development | DevelopmentMediacore | Property) => {
  if (development?.publication_title) {
    return development.publication_title
  }
}
export const getDescription = (development: Development | DevelopmentMediacore) => {
  if (development?.description) {
    return development.description
  }
}
export const getStatus = (development: Development | DevelopmentMediacore) => {
  if (development?.construction_status) {
    if (development.construction_status === 1) {
      return 'Desconocido'
    }
    if (development.construction_status === 2) {
      return 'Reuniendo inversores'
    }
    if (development.construction_status === 3) {
      return 'En pozo'
    }
    if (development.construction_status === 4) {
      return 'En Construcción'
    }
    if (development.construction_status === 5) {
      return 'Construcción detenida'
    }
    if (development.construction_status === 6) {
      return 'Construcción Terminada'
    } else {
      return development.construction_status
    }
  }
}
export const getType = (development: Development) => {
  if (development?.type) {
    return development.type.name
  }
  return ''
}
export const getContructionDate = (development: Development) => {
  let month = ''
  if (development?.construction_date) {
    switch (development.construction_date.split('-')[1]) {
      case '01':
        month = 'Enero'
        break
      case '02':
        month = 'Febrero'
        break
      case '03':
        month = 'Marzo'
        break
      case '04':
        month = 'Abril'
        break
      case '05':
        month = 'Mayo'
        break
      case '06':
        month = 'Junio'
        break
      case '07':
        month = 'Julio'
        break
      case '08':
        month = 'Agosto'
        break
      case '09':
        month = 'Septiembre'
        break
      case '10':
        month = 'Octubre'
        break
      case '11':
        month = 'Noviembre'
        break
      case '12':
        month = 'Diciembre'
        break
    }
    return month + ' de ' + development.construction_date.split('-')[0]
  }
}
// export const group_Unities = (data,filter = 0, ids=[]) => {
//     const array = [
//     ];
//     for (let i = 0; i < data.length; i++) {
//       // Armo la nueva unidad en un objeto, separo piso de la unidad en el titulo
//       if(filter === data[i].room_amount || filter === 0){
//           let object = {}
//           if(data[i].id !== 741886){
//             object = {
//               floor: data[i].real_address.split("-")[0].normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
//               unity: {
//                 fake_address:data[i].fake_address,
//                 address:data[i].real_address.split("-")[1],
//                 // address:data[i].real_address.replace(data[i].real_address.split("-")[0]+"-",''),
//                 id:data[i].id,
//                 status:data[i]?.status,
//                 type:data[i]?.type?.name,
//                 location:data[i]?.location.name,
//                 surface:data[i]?.roofed_surface,
//                 surface_total:data[i].total_surface,
//                 rooms:data[i].room_amount,
//                 operation:data[i]?.operations[0]?.operation_type,
//                 price: data[i].web_price ? data[i]?.operations[0]?.prices[0]?.price : 'Precio a consultar',
//                 previous_price: data[i]?.operations[0]?.prices[0]?.is_less_than_previous_price ? data[i]?.operations[0]?.prices[0].previous_price : 0,
//                 currency:data[i].web_price ? data[i]?.operations[0]?.prices[0]?.currency : '',
//               }
//             }
//           }

//           // // Verifico si existe el piso o lo tengo que crear
//           const finder = array.find(element => element.floor === object.floor)
//           if(array.find(element => element.floor === object.floor)){
//             if((ids.length > 0 && ids.indexOf(data[i].id.toString()) !== -1) || ids.length === 0){
//               finder.unities.push(object.unity)
//             }
//           }
//           else{
//             if((ids.length > 0 && ids.indexOf(data[i].id.toString()) !== -1) || ids.length === 0){
//               array.push({
//                 floor:object.floor.normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
//                 unities:[object.unity]
//               })
//             }
//           }
//       }
//     }

//     let pisos = []
//     let area = []
//     let subsuelos = []
//     let nivel = []
//     let duplex = []
//     let barrio = []

//     let response= [];

//     for (const iterator of array) {
//       if(iterator.floor.split(" ")[0].toLowerCase().includes("piso")){
//         if(iterator.floor.includes("PB")){
//           pisos.unshift(iterator);
//         }
//         else{
//           pisos.push(iterator);
//         }
//       }
//       if(iterator.floor.split(" ")[0].toLowerCase().includes("subsuelo")){
//         subsuelos.push(iterator);
//       }
//       if(iterator.floor.split(" ")[0].toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes("area")){
//         area.push(iterator);
//       }
//       if(iterator.floor.split(" ")[0].toLowerCase().includes("nivel")){
//         nivel.push(iterator);
//       }
//       if(iterator.floor.split(" ")[0].toLowerCase().includes("dúplex")){
//         duplex.push(iterator);
//       }
//       if(iterator.floor.split(" ")[0].toLowerCase().includes("barrio")){
//         barrio.push(iterator);
//       }

//     }

//     pisos = pisos.sort(function(a, b){return a.floor.split(" ")[1] - b.floor.split(" ")[1]})
//     area = area.sort(function(a, b){return a.floor.split(" ")[1] - b.floor.split(" ")[1]})
//     subsuelos = subsuelos.sort(function(a, b){return a.floor.split(" ")[1] - b.floor.split(" ")[1]})
//     duplex = duplex.sort(function(a, b){return a.floor.split(" ")[1] - b.floor.split(" ")[1]})
//     barrio = barrio.sort(function(a, b){return a.floor.split(" ")[1] - b.floor.split(" ")[1]})

//     for (const iterator of subsuelos) {
//       response.push(iterator);
//     }
//     for (const iterator of nivel) {
//       response.push(iterator);
//     }
//     for (const iterator of pisos) {
//       response.push(iterator);
//     }
//     for (const iterator of area) {
//       response.push(iterator);
//     }
//     for (const iterator of duplex) {
//       response.push(iterator);
//     }
//     for (const iterator of barrio) {
//       response.push(iterator);
//     }

//     return response;
//     // return array.sort(function(a, b){return a.floor - b.floor});
// }

export const is_Sold = (development: Development) => {
  if (development?.custom_tags) {
    for (const iterator of development?.custom_tags) {
      if (iterator.name === '100vendido') {
        return true
      }
    }
  }
  return false
}
export const getLastFeatured = (developments: Development[]) => {
  return developments
    ?.filter((development: Development) => development?.is_starred_on_web)
    .slice(-1)[0]
}
export const getReverseOrder = (
  developments: Development[] | DevelopmentMediacore[],
  inverted?: Boolean | undefined,
) => {
  // return developments
  const mapped: any = developments?.map((dev) => dev)!
  return (
    mapped?.sort((a: Development, b: Development) => (inverted ? a.id - b.id : b.id - a.id)) || []
  )
}
export const getCustomTags = (developments: Development[], group?: string) => {
  const custom_tags = []
  if (developments) {
    const developments_filtered = developments?.filter(
      (element) =>
        !element.custom_tags.find((tag: CustomTagTokko) => tag.name.toLowerCase() === 'portada'),
    )
    for (const development of developments_filtered) {
      for (const tag of development.custom_tags) {
        if (
          tag.group_name === group &&
          tag.name.toLowerCase() !== 'portada' &&
          custom_tags.filter((element) => element.name === tag.name).length === 0
        ) {
          custom_tags.push(tag)
        }
      }
    }
  }
  return custom_tags
}

export const getGroupDevelopment = (developments: Development[]) => {
  const developments_filtered = developments.filter((element) =>
    element.custom_tags.find((tag) => tag.name.toLowerCase() === 'portada'),
  )
  return developments_filtered
}
export const group_Unities = (data: Property[], filter = 0, ids: any = []) => {
  const array: any = []
  for (let i = 0; i < data.length; i++) {
    // Armo la nueva unidad en un objeto, separo piso de la unidad en el titulo
    if (filter === data[i].room_amount || filter === 0) {
      let object: any = {}
      if (data[i].id !== 741886) {
        object = {
          floor: data[i].real_address
            .split('-')[0]
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, ''),
          unity: {
            fake_address: data[i].fake_address,
            address: data[i].real_address.split('-')[1],
            // address:data[i].real_address.replace(data[i].real_address.split("-")[0]+"-",''),
            id: data[i].id,
            status: data[i]?.status,
            type: data[i]?.type?.name,
            location: data[i]?.location.name,
            surface: data[i]?.roofed_surface.split('.00')[0],
            surface_total: data[i].total_surface.split('.00')[0],
            rooms: data[i].room_amount,
            web_price: data[i].web_price,
            photos: data[i].photos,
            operations: data[i].operations.map((op, index) => ({ ...op, prices: op.prices[0] })),
            price: data[i].web_price ? data[i]?.operations[0]?.prices[0]?.price : 'A consultar',
            previous_price: data[i]?.operations[0]?.prices[0]?.is_less_than_previous_price
              ? data[i]?.operations[0]?.prices[0].previous_price
              : 0,
            currency: data[i].web_price ? data[i]?.operations[0]?.prices[0]?.currency : '',
          },
        }
      }

      // // Verifico si existe el piso o lo tengo que crear
      const finder = array.find((element: any) => element.floor === object.floor)
      if (array.find((element: any) => element.floor === object.floor)) {
        if ((ids.length > 0 && ids.indexOf(data[i].id.toString()) !== -1) || ids.length === 0) {
          finder.unities.push(object.unity)
        }
      } else {
        if ((ids.length > 0 && ids.indexOf(data[i].id.toString()) !== -1) || ids.length === 0) {
          array.push({
            floor: object.floor.normalize('NFD').replace(/[\u0300-\u036f]/g, ''),
            unities: [object.unity],
          })
        }
      }
    }
  }

  let pisos = []
  let area = []
  let subsuelos = []
  let nivel = []
  let duplex = []
  let barrio = []
  let torre = []

  let response = []

  for (const iterator of array) {
    if (iterator.floor.split(' ')[0].toLowerCase().includes('piso')) {
      if (iterator.floor.includes('PB')) {
        pisos.unshift(iterator)
      } else {
        pisos.push(iterator)
      }
    }
    if (iterator.floor.split(' ')[0].toLowerCase().includes('subsuelo')) {
      subsuelos.push(iterator)
    }
    if (
      iterator.floor
        .split(' ')[0]
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .includes('area')
    ) {
      area.push(iterator)
    }
    if (iterator.floor.split(' ')[0].toLowerCase().includes('nivel')) {
      nivel.push(iterator)
    }
    if (iterator.floor.split(' ')[0].toLowerCase().includes('dúplex')) {
      duplex.push(iterator)
    }
    if (iterator.floor.split(' ')[0].toLowerCase().includes('barrio')) {
      barrio.push(iterator)
    }
    if (iterator.floor.split(' ')[0].toLowerCase().includes('torre')) {
      torre.push(iterator)
    }
  }

  pisos = pisos.sort(function (a, b) {
    return a.floor.split(' ')[1] - b.floor.split(' ')[1]
  })
  area = area.sort(function (a, b) {
    return a.floor.split(' ')[1] - b.floor.split(' ')[1]
  })
  subsuelos = subsuelos.sort(function (a, b) {
    return a.floor.split(' ')[1] - b.floor.split(' ')[1]
  })
  duplex = duplex.sort(function (a, b) {
    return a.floor.split(' ')[1] - b.floor.split(' ')[1]
  })
  barrio = barrio.sort(function (a, b) {
    return a.floor.split(' ')[1] - b.floor.split(' ')[1]
  })
  torre = torre.sort(function (a, b) {
    return a.floor.split(' ')[1] - b.floor.split(' ')[1]
  })

  for (const iterator of subsuelos) {
    response.push(iterator)
  }
  for (const iterator of nivel) {
    response.push(iterator)
  }
  for (const iterator of pisos) {
    response.push(iterator)
  }
  for (const iterator of area) {
    response.push(iterator)
  }
  for (const iterator of duplex) {
    response.push(iterator)
  }
  for (const iterator of barrio) {
    response.push(iterator)
  }
  for (const iterator of torre) {
    response.push(iterator)
  }

  return response
  // return array.sort(function(a, b){return a.floor - b.floor});
}

export const excludeIncludeDevelopments = (
  developments: Development[] | DevelopmentMediacore[],
  includeTag: string[],
  excludeTag: string[],
) => {
  let devs: any = developments
  let developments_filtered: any = includeTag?.length === 0 || !includeTag ? developments : [] //Si no tiene de incluir, solo excluyo o no excluyo nada.
  if (includeTag) {
    for (const itag of includeTag) {
      let development_with_tag = devs.filter((dev: any) =>
        dev.custom_tags.find(
          (tag: { name: string }) =>
            tag.name.normalize().toLowerCase() === itag.normalize().toLowerCase(),
        ),
      )
      devs = devs.filter(
        (dev: any) =>
          !dev.custom_tags.find(
            (tag: { name: string }) =>
              tag.name.normalize().toLowerCase() === itag.normalize().toLowerCase(),
          ),
      )
      developments_filtered = [...developments_filtered, ...development_with_tag]
    }
  }
  if (excludeTag) {
    for (const etag of excludeTag) {
      developments_filtered = developments_filtered.filter(
        (dev: Development) =>
          !dev.custom_tags.find((tag) => tag.name.toLowerCase() === etag.toLowerCase()),
      )
    }
  }
  return developments_filtered
}
